<template>
  <div>
    <meta name="Description" content="📄 Post your job everywhere in less than 2 minutes." />
    <Header />
    <router-view />
    <!--
    <button v-if="deferredPrompt" id="pwa" class="primary-button install-button">
      Add to home screen
    </button>
    -->
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  components: {
    Header,
    Footer,
  },

  data() {
    return {
      deferredPrompt: null,
    };
  },

  /*
  mounted() {
    // PWA - Documentation
    // https://www.simicart.com/blog/pwa-add-to-home-screen/
    window.addEventListener('beforeinstallprompt', (e) => {
      this.deferredPrompt = e
    })
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.deferredPrompt = e
      const installButton = document.getElementById('pwa')
      installButton.style.display = 'block'
      installButton.addEventListener('click', () => {
        installButton.style.display = 'none'
        this.deferredPrompt.prompt()
        this.deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              firebase.analytics.logEvent('pwa-install-accepted')
            } else {
              firebase.analytics.logEvent('pwa-install-rejected')
            }
            this.deferredPrompt = null
          })
      })
    })
  },
  */
};
</script>

<style>
@import "./assets/styles/common.css";
@import "./assets/styles/config.css";
* {
  box-sizing: border-box;
}
body {
  padding: 0rem;
  margin: 0rem;
  font-size: 1rem;
  background-color: var(--global-background-color);
}
button {
  font-size: 14px;
  color: var(--secondary-text-color);
  background-color: var(--primary-color);
}
input {
  font-size: 1rem;
  font-family: "Inter", sans-serif;
}
input:hover {
  border-color: var(--primary-color);
}
p {
  color: var(--primary-text-light-color);
  line-height: 1.5rem;
}
h1 {
  font-size: 2em;
  color: var(--primary-text-color);
}
h2 {
  font-size: 1.8em;
  color: var(--primary-text-color);
}
h3 {
  font-size: 1.6em;
  color: var(--primary-text-color);
}
a {
  color: var(--link-text-color);
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
hr {
  margin-top: 5rem;
  margin-bottom: 3rem;
}
textarea {
  font-family: "Inter", sans-serif;
  font-size: 1rem;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

::-webkit-input-placeholder {
  color: var(--primary-text-light-color);
  font-size: 1rem;
  font-family: "Inter", sans-serif;
}

::-ms-input-placeholder {
  color: var(--primary-text-light-color);
  font-size: 1rem;
  font-family: "Inter", sans-serif;
}

::placeholder {
  color: var(--primary-text-light-color);
  font-size: 1rem;
  font-family: "Inter", sans-serif;
}

#app {
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#nav {
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.install-button {
  display: hidden;
  position: fixed;
  bottom: 5px;
  right: 5px;
}
@media (max-width: 760px) {
  .install-button {
    display: hidden;
    position: fixed;
    bottom: 0px;
  }
}
</style>
